export default __webpack_public_path__ + "static/media/logo-tabsters.08897ea6.jpg";